/**
 * Whether a contract bills on the subsidised tariff rows, the subsidised week
 * factor and the subsidised BABY->CHILD threshold.
 *
 * Mirrors the backend `billing.UsesSubsidisedRates`: subsidised rates are a
 * City-of-Zurich concept, so only a subsidised contract whose office runs the
 * `zurich_bf` method uses them. A flat office (and a subsidised contract with
 * no office yet, i.e. decision pending) bills on the normal tariffs.
 * `subsidised` alone only means "an office pays part of this contract".
 */
export function usesSubsidisedRates(
  subsidised: boolean | undefined,
  subsidyOfficeId: string | null | undefined,
  officeMethod: "zurich_bf" | "flat",
): boolean {
  return !!subsidised && !!subsidyOfficeId && officeMethod === "zurich_bf";
}
